import React from 'react'
import { ChromePicker } from 'react-color'
import ReactTooltip from 'react-tooltip'
import Arrow from '../Arrow'
import { classnames } from '../../helpers'
import './style.scss'

const Select = ({ id, tooltip, options = [], label, value, onChange, color }) => {
  const [isOpened, setOpened] = React.useState(false)
  const ref = React.useRef(null)

  const handleOpen = React.useCallback(() => {
    setOpened(true)
  }, [])

  const handleClose = React.useCallback(() => {
    setOpened(false)
  }, [])

  const handleChange = React.useCallback(value => e => {
    if (onChange) {
      onChange(value)
    }
    handleClose()
  }, [onChange, handleClose])

  const handleOutsideClick = React.useCallback(event => {
    if (isOpened && ref.current && !ref.current.contains(event.target)) {
      handleClose()
    }
  }, [handleClose, ref, isOpened])

  React.useEffect(() => {
    document.addEventListener('click', handleOutsideClick, false)
    return () => {
      document.removeEventListener('click', handleOutsideClick, false)
    }
  }, [handleOutsideClick])

  const handleColorChange = React.useCallback((color) => {
    if (onChange) {
      onChange(color.hex)
    }
    // handleClose()
  }, [onChange])

  if (color) {
    return (
      <div className="default-select-wrapper">
        <div className="default-label">{label}</div>
        <div className="input-wrapper" onClick={handleOpen}>
          <input className="default-input" type="text" value={value} disabled />
        </div>
        <div
          className={classnames({
            'menu-wrapper': true,
            opened: isOpened,
          })}
          ref={ref}
        >
          <ChromePicker width="100%" color={value}  onChangeComplete={handleColorChange} />
        </div>
      </div>
    )
  }

  return (
    <div className="default-select-wrapper">
      <div className="default-label">{label}</div>
      {tooltip && (
        <ReactTooltip id={id} effect='solid' />
      )}
      <div className="input-wrapper" data-for={id} data-tip={tooltip}>
        <input className="default-input" type="text" value={value} disabled />
        <div className="arrow" onClick={handleOpen}>
          <Arrow />
        </div>
      </div>
      <div
        className={classnames({
          'menu-wrapper': true,
          opened: isOpened,
        })}
        ref={ref}
      >
        {options.map(option => (
          <div
            key={option.value}
            className={classnames({
              'menu-item': true,
              selected: value === option.value
            })}
            onClick={handleChange(option.value)}
          >
            <div>{option.label}</div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Select
